export const modelSelectConfig = {
    header: {
        title: "Выберите модель зарядной станции",
    },
    columns: [
        {
            title: "Название",
            dataIndex: "name",
            key: "name",
            sorter: true,
        },
        {
            title: "Мощность (кВт)",
            dataIndex: "powerKw",
            key: "powerKw",
            sorter: true,
            render: (power) => `${power} кВт`,
        },
        {
            title: "Количество портов",
            dataIndex: "portCount",
            key: "portCount",
            sorter: true,
            render: (count) => count,
        },
        {
            title: "Макс. ток (А)",
            dataIndex: "maxCurrentA",
            key: "maxCurrentA",
            sorter: true,
            render: (current) => `${current} А`,
        },
        {
            title: "Входное напряжение (В)",
            dataIndex: "inputVoltage",
            key: "inputVoltage",
            sorter: true,
            render: (voltage) => `${voltage} В`,
        },
    ],
    rowKey: "id",
    scroll: { x: 800 },
};
